import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getMissionSliceContent = createAsyncThunk('/missions/content', async () => {
    var userData=JSON.parse(localStorage.getItem("userData"));
	const response = await axios.post(`${API_URL}/getMission`, {});
	return response;
})

export const missionSlice = createSlice({
    name: 'missions',
    initialState: {
        isLoading: false,
        missions : []
    },
    reducers: {
    },
    extraReducers: {
		[getMissionSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getMissionSliceContent.fulfilled]: (state, action) => {
			state.missions = action.payload.data
			state.isLoading = false
		},
		[getMissionSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default missionSlice.reducer